$(document).ready(function () {
    $("#contactForm .button-check-all").on("click", function() {

        $('#contactForm_AgreeEmail').prop("checked", true);
        $('#contactForm_AgreePhone').prop("checked", true);
        $('#contactForm_AgreeRegulations1').prop("checked", true);
        $('#contactForm_AgreeRegulations2').prop("checked", true);
    });

    $("#contactForm").submit(function (event) {
 
        event.preventDefault();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').empty();

        var errors = 0;

        var firstname = $('#contactForm_firstname').val();
        $('.contactForm-register-firstname .invalid-feedback').empty();
        $('#contactForm_firstname').removeClass('is-invalid');
        if (!firstname) {
            $('#contactForm_firstname').addClass('is-invalid');
            $('.contactForm-register-firstname .invalid-feedback').html('<p>To pole jest wymagane.</p>');
            errors = 1;
        } else if (firstname.length < 3) {
            $('#contactForm_firstname').addClass('is-invalid');
            $('.contactForm-register-firstname .invalid-feedback').html('<p>Imię musi zawierać minimum trzy litery.</p>');
            errors = 1;
        }

        var lastname = $('#contactForm_lastname').val();
        $('.contactForm-register-lastname .invalid-feedback').empty();
        $('#contactForm_lastname').removeClass('is-invalid');
        if (!lastname) {
            $('#contactForm_lastname').addClass('is-invalid');
            $('.contactForm-register-lastname .invalid-feedback').html('<p>To pole jest wymagane.</p>');
            errors = 1;
        } else if (lastname.length < 3) {
            $('#contactForm_lastname').addClass('is-invalid');
            $('.contactForm-register-lastname .invalid-feedback').html('<p>Nazwisko musi zawierać minimum trzy litery.</p>');
            errors = 1;
        }

        var email = $('#contactForm_email').val();
        $('.contactForm-register-email .invalid-feedback').empty();
        $('#contactForm_email').removeClass('is-invalid');
        if (email) {
            if (!(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email))) {
                $('#contactForm_email').addClass('is-invalid');
                $('.contactForm-register-email .invalid-feedback').html('<p>Wpisz poprawny adres e-mail.</p>');
                errors = 1;
            }
        }
        var phoneInput = $('#contactForm_phone');
        

        var phone = phoneInput.val();
        $('.contactForm-register-phone .invalid-feedback').empty();
        $('#contactForm_phone').removeClass('is-invalid');
        if (phone) {
            if (phone.length != 9 || !(/^[0-9]+$/.test(phone))) {
                $('#contactForm_phone').addClass('is-invalid');
                $('.contactForm-register-phone .invalid-feedback').html('<p>Wpisz poprawny 9-cyfrowy numer telefonu.</p>');
                errors = 1;
            }
        }

        var message = $('#contactForm_question').val();
        var agree1 = $('#contactForm_AgreeEmail').prop('checked');
        var agree2 = $('#contactForm_AgreePhone').prop('checked');
        var agree3 = $('#contactForm_AgreeRegulations1').prop('checked');
        var agree4 = $('#contactForm_AgreeRegulations2').prop('checked');

        if (!agree1 && !agree2) {
            $('#contactForm_AgreeEmail').addClass('is-invalid');
            $('.contactForm-agree-email').html('<p>Proszę wyrazić zgodę na co najmniej jeden sposób kontaktu.</p>');
            $('#contactForm_AgreePhone').addClass('is-invalid');
            $('.contactForm-agree-phone').html('<p>Proszę wyrazić zgodę na co najmniej jeden sposób kontaktu.</p>');
            errors = 1;
        } else {
            $('#contactForm_AgreeEmail').removeClass('is-invalid');
            $('.contactForm-agree-email').empty();
            $('#contactForm_AgreePhone').removeClass('is-invalid');
            $('.contactForm-agree-phone').empty();
        }

        if (!email && !phone) {
            $('#contactForm_email').addClass('is-invalid');
            $('.contactForm-register-email .invalid-feedback').html('<p>Proszę podać co najmniej jeden sposób kontaktu.</p>');
            $('#contactForm_phone').addClass('is-invalid');
            $('.contactForm-register-phone .invalid-feedback').html('<p>Proszę podać co najmniej jeden sposób kontaktu.</p>');
            errors = 1;
        }

        var emailCheckbox = $('#contactForm_email');
        var agree1 = $('#contactForm_AgreeEmail');

        if (agree1.is(':checked')) {
            if (emailCheckbox.val() === '') {
                var errors = 1;
                $('.contactForm-agree-email').html('<p> Nie podałes E-maila </p>').show();
            }
        }


        var phoneCheckbox = $('#contactForm_phone');
        var agree2 = $('#contactForm_AgreePhone');

        if (agree2.is(':checked')) {
            if (phoneCheckbox.val() === '') {
                var errors = 1;
                $('.contactForm-agree-phone').html('<p> Nie podałes numeru telefonu </p>').show();
            }
        }


        $('#contactForm_AgreeRegulations1').removeClass('is-invalid');
        $('.contactForm-agree-regulations1').empty();
        if (!agree3) {
            $('#contactForm_AgreeRegulations1').addClass('is-invalid');
            $('.contactForm-agree-regulations1').html('<p>To pole jest wymagane.</p>');
            errors = 1;
        }


        var dealer = $('#contactForm_dealer').val();
        console.log(errors);
        if (errors == 0) {
            $('#contactForm .btn-form').attr("disabled", "true");    
            $.ajax({
                type: 'POST',
                url: '/kontakt',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    message: message,
                    dealer: dealer,
                    agree_regulations1: (agree1 ? 'yes' : 'no'),
                    agree_regulations2: (agree2 ? 'yes' : 'no'),
                    agree_regulations3: (agree3 ? 'yes' : 'no'),
                    agree_regulations4: (agree4 ? 'yes' : 'no')
                },
                success: function (response) {
                    $('#contactForm .btn-form').removeAttr("disabled");
                    
                    if (response.success) {
                        $('#formSuccess').modal('show')
                        $("#contactForm").trigger("reset");

                    } else {
                        if (response.errors) {
                            $('#contactForm_firstname').removeClass('is-invalid');
                            $('.contactForm-register-firstname .invalid-feedback').empty();
                            $('#contactForm_lastname').removeClass('is-invalid');
                            $('.contactForm-register-lastname .invalid-feedback').empty();
                            $('#contactForm_email').removeClass('is-invalid');
                            $('.contactForm-register-email .invalid-feedback').empty();
                            $('#contactForm_phone').removeClass('is-invalid');
                            $('.contactForm-register-phone .invalid-feedback').empty();
                            $('#contactForm_question').removeClass('is-invalid');
                            $('.contactForm-register-question .invalid-feedback').empty();
                            $('#contactForm_AgreeRegulations2').removeClass('is-invalid');
                            $('.contactForm-agree-email').empty();
                            $('#contactForm_AgreePhone').removeClass('is-invalid');
                            $('.contactForm-agree-phone').empty();
                            $('#contactForm_AgreeRegulations1').removeClass('is-invalid');
                            $('.contactForm-agree-regulations1').empty();
                            $('#contactForm_AgreeRegulations2').removeClass('is-invalid');
                            $('.contactForm-agree-regulations2').empty();
                            
                            if (response.errors.hasOwnProperty('firstname')) {
                                $('#contactForm_firstname').addClass('is-invalid');
                                $('.contactForm-register-firstname .invalid-feedback').html('<p>' + response.errors['firstname'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('lastname')) {
                                $('#contactForm_lastname').addClass('is-invalid');
                                $('.contactForm-register-lastname .invalid-feedback').html('<p>' + response.errors['lastname'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('email')) {
                                $('#contactForm_email').addClass('is-invalid');
                                $('.contactForm-register-email .invalid-feedback').html('<p>' + response.errors['email'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('phone')) {
                                $('#contactForm_phone').addClass('is-invalid');
                                $('.contactForm-register-phone .invalid-feedback').html('<p>' + response.errors['phone'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('message')) {
                                $('#contactForm_question').addClass('is-invalid');
                                $('.contactForm-register-question .invalid-feedback').html('<p>' + response.errors['message'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('agree_regulations1')) {
                                $('.form-check-input#contactForm_AgreeEmail').addClass('is-invalid');
                                $('.contactForm-agree-email').html('<p>' + response.errors['agree_regulations1'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('agree_regulations2')) {
                                $('.form-check-input#contactForm_AgreePhone').addClass('is-invalid');
                                $('.contactForm-agree-phone').html('<p>' + response.errors['agree_regulations2'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('agree_regulations3')) {
                                $('#contactForm_AgreeRegulations1').addClass('is-invalid');
                                $('.contactForm-agree-regulations1').html('<p>' + response.errors['agree_regulations3'].join(' ') + '</p>');
                            }
                            if (response.errors.hasOwnProperty('agree_regulations4')) {
                                $('#contactForm_AgreeRegulations2').addClass('is-invalid');
                                $('.contactForm-agree-regulations2').html('<p>' + response.errors['agree_regulations4'].join(' ') + '</p>');
                            }

                        } else {
                            alert('Zapis nie powiódł się. Spróbuj ponownie');
                        }
                    }
                }
            });
        }
    });
    $('#contactForm_question').on('input', function() {
        var currentLength = $(this).val().length;
        const remaining = 300 - currentLength;
        $('#contactForm_QuestionHelp').text(`Wykorzystano ${currentLength}/300 znaków`);
    });
});